function fetchIpInfoData(callback) {
  fetch("https://ipinfo.io/json")
    .then((response) => response.json())
    .then((data) => callback(data));
}

function getIsCountryField(element) {
  return $(element).parents(".gform__country-field").length > 0;
}

function getCountryFields() {
  let countryFields = [];

  window.$selects.each(function () {
    if (getIsCountryField(this)) {
      countryFields.push(this);
    }
  });

  return countryFields;
}

export default function () {
  const fields = getCountryFields();

  if (fields.length === 0) {
    return;
  }

  fetchIpInfoData((data) => {
    const regionNames = new Intl.DisplayNames(["en"], { type: "region" });
    const country = regionNames.of(data.country);

    fields.forEach((field) => {
      if ($(field).length === 0) {
        return;
      }
      try {
        field.selectize.setValue(country);
      } catch (error) {
        // In case selectize is not being used, then try
        // setting the value the normal way
        $(field).val(country);
      }
    });
  });
}
